namespace $.$$ {
	export class $giper_baza_flex_field extends $.$giper_baza_flex_field {
		
		override dict_pawn() {
			return this.pawn() as $giper_baza_dict
		}
		
		@ $mol_mem
		schema() {
			const type = this.prop().Type()?.val() ?? 'str'
			switch( type ) {
				case 'vary': return null
				case 'enum': return null
				case 'bool': return 'Bool'
				case 'int': return 'Bint'
				case 'real': return 'Real'
				case 'str': return 'Text'
				case 'link': return null
				case 'time': return null
				case 'dict': return null
				case 'text': return null
				case 'rich': return null
				case 'list': return null
				default: return null
			}
		}
		
		@ $mol_mem
		Sub() {
			const type = this.prop().Type()?.val() ?? 'str'
			switch( type ) {
				case 'vary': return this.Atom()
				case 'enum': return this.Enum()
				case 'bool': return this.Atom()
				case 'int': return this.Atom()
				case 'real': return this.Atom()
				case 'str': return this.Atom()
				case 'link': return this.Ref()
				case 'time': return this.Atom()
				case 'dict': return this.Dict()
				case 'text': return this.Text()
				case 'rich': return this.Rich()
				case 'list': return this.List()
				default: return $mol_fail( new Error( `Unsuported Pawn type (${type})` ) )
			}
		}
		
		override enum( next?: $giper_baza_vary_type ) {
			return this.pawn( next as any )?.cast( $giper_baza_atom ).vary( next ) ?? null
		}
		
		@ $mol_mem
		override enum_options() {
			return this.prop().Enum()?.remote()?.items_vary() ?? []
		}
		
		@ $mol_mem_key
		override enum_label( option: $giper_baza_vary_type ) {
			return $mol_schema_string.cast( option )
		}
		
		atom_value( next?: $giper_baza_vary_type ) {
			return this.pawn( next as any )?.cast( $giper_baza_atom ).vary( next ) ?? null
		}
		
		atom_selection( next?: readonly[ path: string, begin: number, end: number ] ) {
			
			const link = this.pawn()?.head().str ?? ''
			const user = this.$.$giper_baza_glob.Land( this.$.$giper_baza_auth.current().pass().lord() ).Data( $giper_baza_flex_user )
			
			if( next ) {
				
				user.caret([ [ link + next[0], next[1], 0 ], [ link + next[0], next[2], 0 ] ])
				return next
				
			} else {
				
				this.atom_value() // track text to recalc selection on its change
				
				const sel = user.caret()
				if( !sel ) return [ '', 0, 0 ]
				if( !sel[0][0].startsWith( link ) ) return [ '', 0, 0 ]
				if( !sel[1][0].startsWith( link ) ) return [ '', 0, 0 ]
				
				return [ sel[0][0].slice( link.length ), sel[0][1], sel[1][1] ]
			}

		}
		
		link( next?: $giper_baza_link ) {
			this.pawn( next as any )?.cast( $giper_baza_atom_link ).val( next ) ?? null
			return null
		}
		
		@ $mol_mem
		link_content() {
			return [
				... this.link_value() === null ? [] : [ this.Link_dump() ],
				... this.link_options().length ? [ this.Link_pick() ] : [],
				... this.link_value() === null ? [ this.Link_new() ] : [],
			]
		}
		
		@ $mol_mem
		link_value() {
			return this.pawn()?.cast( $giper_baza_atom ).vary() ?? null
		}
		
		link_options() {
			return this.prop().Enum()?.remote()?.items_vary() ?? []
		}
		
		link_label( link: $giper_baza_vary_type ) {
			if( link instanceof $giper_baza_link ) return this.$.$giper_baza_glob.Pawn( link, $giper_baza_flex_subj ).Name()?.val() ?? link.str
			return $mol_schema_string.cast( link )
		}
		
		link_remote() {
			return ( this.pawn().cast( $giper_baza_atom_link.to( ()=> $giper_baza_dict ) ) ).remote()!
		}
		
		@ $mol_action
		link_new( rights?: string ) {
			
			if( !rights ) return null
			
			const pawn =  this.pawn( 'auto' as any ).cast( $giper_baza_flex_subj_link )
			const Target = this.prop().Kind()?.remote()
			
			if( rights === 'local' ) {
				const remote = pawn.ensure(null)!
				if( Target ) remote.meta( Target.link() )
				return null
			}
			
			const preset = ( {
				deny: [],
				read: [[ null, $giper_baza_rank_read ]],
				post: [[ null, $giper_baza_rank_post( 'just' ) ]],
				pull: [[ null, $giper_baza_rank_pull( 'just' ) ]],
			} as Record< string, $giper_baza_rank_preset > )[ rights as any ]
			
			if( preset ) {
				const remote = pawn.ensure( preset )!
				if( Target ) remote.meta( Target.link() )
				return null
			}
			
			return null
		}
		
		text( next?: string ) {
			return this.pawn( next as any )?.cast( $giper_baza_text ).value( next ) ?? ''
		}
		
		text_selection( next?: readonly[ begin: number, end: number ] ) {
			return this.pawn( next as any )?.cast( $giper_baza_text ).selection( this.land().auth().pass().lord(), next )
		}
		
		@ $mol_mem
		rich_pawn( next?: any ) {
			return this.pawn( next )?.cast( $giper_baza_rich ) ?? null!
		}
		
		@ $mol_mem
		dict_title() {
			return this.pawn()?.cast( $giper_baza_entity ).Title()?.val() || this.pawn().link().str
		}

		@ $mol_mem
		list_items() {
			return this.pawn()?.units().map( ( _, index )=> this.List_item( index ) ) ?? []
		}
		
		@ $mol_mem
		list_tools() {
			return [
				... this.link_options().length ? [ this.List_pick() ] : [],
				this.List_item_add(),
				this.List_item_paste(),
			]
		}
		
		list_pick( next?: $giper_baza_link ) {
			if( !next ) return null
			this.pawn( next as any )?.cast( $giper_baza_list ).add( next )
			return null
		}
		
		@ $mol_action
		list_item_add() {
			const target = this.pawn( null as any ).cast( $giper_baza_list_link.to( ()=> $giper_baza_flex_subj ) ).make( null )
			const meta = this.prop().Kind()?.remote()?.link() ?? null
			if( meta ) target.meta( meta )
		}
	
		@ $mol_action
		list_item_paste() {
			const str = $mol_wire_sync( navigator.clipboard ).readText()
			let val = str as $giper_baza_vary_type
			const Target = this.prop().Kind()?.remote()
			if( Target ) {
				const link = str.match( $giper_baza_link )?.at( -1 )
				if( !link ) return null
				val = new $giper_baza_link( link )
			}
			this.pawn( null as any ).cast( $giper_baza_list ).add( val )
		}
		
		@ $mol_action
		list_item_kill( sand: $giper_baza_unit_sand ) {
			const list = this.pawn( null as any ).cast( $giper_baza_list )
			const index = list.units().indexOf( sand )
			list.wipe( index )
		}
		
		@ $mol_mem_key
		list_item_sand( index: number ) {
			return this.pawn()?.units()[ index ] ?? null
		}
		
		list_item_text( index: number ) {
			const sand = this.list_item_sand( index )
			if( !sand ) return ''
			return String( this.land().sand_decode( sand ) )
		}
		
		list_item_adopt( transfer : DataTransfer ) {
			return $giper_baza_vary.take( $mol_base64_decode( transfer.getData( "text/plain" ) ) )[0] as $giper_baza_vary_type
		}

		list_item_receive( index: number, value: $giper_baza_vary_type ) {
			const list = this.pawn()!.cast( $giper_baza_list )
			list.splice( [ value ], index )
		}
		
		list_receive( value: string ) {
			const list = this.pawn()!.cast( $giper_baza_list )
			list.splice( [ value ] )
		}
		
		list_item_drag_end( index: number, event: DragEvent ) {
			if( event.dataTransfer?.dropEffect !== 'move' ) return
			this.land().sand_wipe( this.list_item_sand( index ) )
		}
		
	}
}
